import { Box, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

export default function Timer({ modeSignin, initialSeconds, initialMinute }) {
  // const Timer = (props) => {
  //   const { initialMinute = 0, initialSeconds = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  return (
    <>
      
      <Box display="flex" mt='15px' >
        <Typography fontSize="14px" color='#6CBBC7' ml='5px' >{"ارسال مجدد کد تایید"}</Typography>
        {minutes === 0 && seconds === 0 ? null : (
          <Typography fontSize="14px" color='#6CBBC7'>
            {"("}
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            {")"}
          </Typography>
        )}
      </Box>
    </>
  );
}
// export default Timer;
// }
